<style lang="sass" rel="stylesheet/sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import sass/variables
@import sass/heading
</style>
<script>
function isHeadingLevel (value) {
    return value <= 6 || !value
}

export default {
    name: 'heading',
    props: {
        level: {
            type: Number,
            default: 2,
            validator: isHeadingLevel
        },
        levelClass: {
            type: Number,
            default: null,
            validator: isHeadingLevel
        },
        fake: {
            type: Boolean,
            default: false
        },
        noMargin: {
            type: Boolean,
            default: false
        }
    },
    render: function (createElement) {
        let el = `h${this.level}`
        let className = `g_${el}`

        // If we have an H1 in hero
        if (this.level === 1) {
            el = 'h1'
            className = `g_h1`
        } else {
            // Overwrte default classe lvl
            if (this.levelClass) {
                className = `g_h${this.levelClass}`
            }
        }

        if (this.noMargin) {
            className += '_nomargin'
        }

        if (this.fake) {
            el = 'p'
        }

        return createElement(
            el,
            {
                attrs: {
                    class: className.trim()
                }
            },
            this.$slots.default
        )
    }
}
</script>
